const snack = require("../../../../../components/snack/snack");
const scrim = require("../../../../../components/scrim/scrim");
const textfieldHandler = require("../../../../../components/textfield/textfield-handler");
const { getReportDefinition } = require("./reportHub-report-registry");

let activeDefinition = null;
const REPORT_PDF_ENDPOINT = "server/php/report/report-pdf.php";
const REPORT_SHEET_ENDPOINT = "server/php/report/report-csv.php";

const AUTOCOMPLETE_IDS = [
  "reportHub_form_customer_id",
  "reportHub_form_provider_id",
  "reportHub_form_purchase_id",
  "reportHub_form_sale_id",
  "reportHub_form_item_id",
  "reportHub_form_receivepayment_id",
  "reportHub_form_sentpayment_id",
  "reportHub_form_otherexpense_id",
];

// --- Helpers de DOM ---
const getEl = (id) => document.getElementById(id);
const getElValue = (id) => getEl(id)?.value || "";

const toggleVisibility = (el, show) => el?.classList.toggle("dn", !show);

function getReportIdFromTrigger(trigger) {
  try {
    const detail = JSON.parse(trigger.getAttribute("data-detail") || "{}");
    const click = Array.isArray(detail.click) ? detail.click : [];
    const reportDetail = click.find((item) => item.by === "selectReport");

    return reportDetail ? reportDetail.reportId : "";
  } catch (e) {
    return "";
  }
}

function applySelectedReportStyle(reportId) {
  const catalog = getEl("reportHub-catalog");
  if (!catalog || !reportId) return;

  catalog.querySelectorAll(".link-active").forEach((el) => {
    el.classList.remove("link-active");
  });

  const triggers = catalog.querySelectorAll("[data-detail]");
  for (let i = 0; i < triggers.length; i += 1) {
    const trigger = triggers[i];

    if (getReportIdFromTrigger(trigger) !== reportId) continue;

    const cont = trigger.closest(".link-list");
    if (cont) cont.classList.add("link-active");
    break;
  }
}

function clearSelectedReportStyle() {
  const catalog = getEl("reportHub-catalog");
  if (!catalog) return;

  catalog.querySelectorAll(".cont-active").forEach((el) => {
    el.classList.remove("cont-active");
  });
}

function getSelectedEntityDbid(elementId) {
  const el = getEl(elementId);
  if (!el) return "";
  try {
    const sel = JSON.parse(el.getAttribute("selected") || "[]");
    return sel.length ? String(sel[0]) : "";
  } catch (e) {
    return "";
  }
}

function clearAutocomplete(elementId) {
  const el = getEl(elementId);
  if (!el) return;

  el.setAttribute("selected", "[]");
  const chipCont = el.querySelector(".chip-cont");
  if (chipCont) chipCont.innerHTML = "";
  const input = el.querySelector(".elem");
  if (input) input.value = "";
}

function clearAllAutocompletes() {
  AUTOCOMPLETE_IDS.forEach(clearAutocomplete);
}

const getSelectedCustomerDbid = () =>
  getSelectedEntityDbid("reportHub_form_customer_id");
const getSelectedProviderDbid = () =>
  getSelectedEntityDbid("reportHub_form_provider_id");

function getAutocompleteEntityId(def) {
  const map = {
    customer: () => getSelectedCustomerDbid(),
    provider: () => getSelectedProviderDbid(),
    purchase: () => getSelectedEntityDbid("reportHub_form_purchase_id"),
    sale: () => getSelectedEntityDbid("reportHub_form_sale_id"),
    item: () => getSelectedEntityDbid("reportHub_form_item_id"),
    transaction: () => getSelectedEntityDbid("reportHub_form_transaction_id"),
    receivepayment: () => getSelectedEntityDbid("reportHub_form_receivepayment_id"),
    sentpayment: () => getSelectedEntityDbid("reportHub_form_sentpayment_id"),
    otherexpense: () => getSelectedEntityDbid("reportHub_form_otherexpense_id"),
  };
  const fn = map[def.autocompleteEntity];
  return fn ? fn() : "";
}

function applyAutocompleteVisibility(def) {
  const wraps = {
    customer: getEl("reportHub-filter-customer-wrap"),
    provider: getEl("reportHub-filter-provider-wrap"),
    purchase: getEl("reportHub-filter-purchase-wrap"),
    sale: getEl("reportHub-filter-sale-wrap"),
    item: getEl("reportHub-filter-item-wrap"),
    transaction: getEl("reportHub-filter-transaction-wrap"),
    receivepayment: getEl("reportHub-filter-receivepayment-wrap"),
    sentpayment: getEl("reportHub-filter-sentpayment-wrap"),
    otherexpense: getEl("reportHub-filter-otherexpense-wrap"),
  };

  Object.keys(wraps).forEach((k) => {
    toggleVisibility(wraps[k], false);
  });

  const entityWrap = getEl("reportHub-filter-entity-wrap");
  toggleVisibility(entityWrap, def.needsAutocomplete);

  if (def.needsAutocomplete && def.autocompleteEntity) {
    toggleVisibility(wraps[def.autocompleteEntity], true);
  }
}

function applyFilterVisibility(def) {
  toggleVisibility(getEl("reportHub-filter-dates"), def.filterDateRange);
  toggleVisibility(getEl("reportHub-filter-year-wrap"), def.filterYear);
  toggleVisibility(getEl("reportHub-filter-period-wrap"), def.filterPeriod);

  applyAutocompleteVisibility(def);
}

function clickFirstVisibleAutocomplete() {
  const entityWrap = getEl("reportHub-filter-entity-wrap");
  if (!entityWrap) return;

  const inputs = entityWrap.querySelectorAll(
    ".textfield-autocomplete .elem[data-detail]"
  );

  for (let i = 0; i < inputs.length; i += 1) {
    const input = inputs[i];
    if (input.closest(".dn")) continue;

    input.focus();
    input.click();
    return;
  }
}

function openFirstAutocompleteFilter(def) {
  if (!def.needsAutocomplete || !def.autocompleteEntity) return;

  setTimeout(() => {
    clickFirstVisibleAutocomplete();
  }, 0);
}

function isHidden(el) {
  return !el || el.closest(".dn");
}

function shakeElement(el) {
  if (!el) return;

  el.classList.remove("a-shake");
  void el.offsetWidth;
  el.classList.add("a-shake");

  setTimeout(() => {
    el.classList.remove("a-shake");
  }, 800);
}

function getGenerateReportButton() {
  const filterCard = getEl("reportHub-filter-card");
  if (!filterCard) return null;

  return filterCard.querySelector('[data-detail*="runFilteredReport"]');
}

function shakeFirstFilterElement() {
  const filterCard = getEl("reportHub-filter-card");
  if (!filterCard || isHidden(filterCard)) return;

  const autocompletes = filterCard.querySelectorAll(".textfield-autocomplete");
  for (let i = 0; i < autocompletes.length; i += 1) {
    const autocomplete = autocompletes[i];
    if (isHidden(autocomplete)) continue;

    shakeElement(autocomplete);
    return;
  }

  const dateFields = filterCard.querySelectorAll('input[type="date"]');
  for (let i = 0; i < dateFields.length; i += 1) {
    const dateField = dateFields[i];
    if (isHidden(dateField)) continue;

    shakeElement(dateField.closest(".textfield") || dateField);
    return;
  }

  shakeElement(getGenerateReportButton());
}

export function initFilters() {
  populateYearSelect();
}

function populateYearSelect() {
  const sel = getEl("reportHub_filter_year_select");
  if (!sel || sel.getAttribute("data-hub-years") === "1") return;
  sel.setAttribute("data-hub-years", "1");
  const y = new Date().getFullYear();
  sel.innerHTML =
    `<option value="" disabled selected>Select year</option>` +
    Array.from({ length: 12 }, (_, i) => {
      const yr = y - i;
      return `<option value="${yr}">${yr}</option>`;
    }).join("");
}

function clearTextfieldByWrapperId(wrapperId) {
  const wrapper = getEl(wrapperId);
  if (wrapper) textfieldHandler.clean(wrapper);
}

function clearFilterInputs() {
  const yearSel = getEl("reportHub_filter_year_select");
  const periodSel = getEl("reportHub_filter_period_select");
  const formatPdfRadio = getEl("reportHub_filter_format_pdf"); // <-- NUEVO: Capturar el radio de PDF

  clearTextfieldByWrapperId("reportHub_wrap_date_from");
  clearTextfieldByWrapperId("reportHub_wrap_date_to");

  if (yearSel) {
    yearSel.selectedIndex = 0;
  }
  if (periodSel) {
    periodSel.selectedIndex = 0;
  }
  if (formatPdfRadio) {
    formatPdfRadio.checked = true; // <-- NUEVO: Volver a marcar PDF por defecto
  }

  clearAllAutocompletes();
}

function updateGeneratingTitle(def) {
  const title = getEl("reportHub-generating-title");
  if (title && def && def.label) {
    title.textContent = "Generating — " + def.label;
  }
}

export function onCleanAll() {
  clearFilterInputs();
  clearSelectedReportStyle();
  toggleVisibility(getEl("reportHub-filter-card"), false);
  activeDefinition = null;
}

function executeReport(def, filters) {
  if (def.needsAutocomplete && !filters.entityId) {
    shakeFirstFilterElement();
    snack.start(getMissingEntitySnack(def));
    return;
  }

  if (def.filterPeriod && !filters.period) {
    getEl("reportHub_filter_period_select")?.focus();
    snack.start({
      act: "show",
      id: "empty",
      msg: "Please, Select a Period",
    });
    return;
  }

  requestPdfReport(def, filters);
}

export function onSelectReport(detail) {
  const def = getReportDefinition(detail.reportId);
  if (!def) return;

  applySelectedReportStyle(detail.reportId);
  activeDefinition = def;
  clearFilterInputs();
  applyFilterVisibility(def);
  updateGeneratingTitle(def);

  const filterCard = getEl("reportHub-filter-card");

  if (def.autoPrintWithoutUI && !def.needsAutocomplete && !def.filterPeriod) {
    toggleVisibility(filterCard, false);
    executeReport(def, buildFiltersFromForm());
    return;
  }

  toggleVisibility(filterCard, true);
  openFirstAutocompleteFilter(def);
  shakeFirstFilterElement();
}

function buildFiltersFromForm() {
  let startDate = getElValue("reportHub_filter_date_from");
  let endDate = getElValue("reportHub_filter_date_to");
  const yearSel = getEl("reportHub_filter_year_select");
  const reportYear =
    yearSel && yearSel.value && !Number.isNaN(Number(yearSel.value))
      ? yearSel.value
      : "";
  const periodSel = getEl("reportHub_filter_period_select");
  const reportPeriod =
    periodSel && periodSel.value && !Number.isNaN(Number(periodSel.value))
      ? periodSel.value
      : "";

  const checkedFormat = document.querySelector('input[name="report_format"]:checked');
  const format = checkedFormat ? checkedFormat.value : "pdf";

  if (
    activeDefinition &&
    activeDefinition.filterYear &&
    reportYear &&
    !startDate &&
    !endDate
  ) {
    startDate = `${reportYear}-01-01`;
    endDate = `${reportYear}-12-31`;
  }

  const filters = {
    startDate,
    endDate,
    useYear: !!reportYear,
    reportYear,
    period:
      activeDefinition && activeDefinition.filterPeriod ? reportPeriod : "",
    entityId:
      activeDefinition && activeDefinition.needsAutocomplete
        ? getAutocompleteEntityId(activeDefinition)
        : "",
    format: format,
  };

  return filters;
}

export function onRunFilteredReport() {
  if (!activeDefinition) return;

  const filters = buildFiltersFromForm();
  if (!filters) return;

  executeReport(activeDefinition, filters);
}

function getMissingEntitySnack(def) {
  const map = {
    customer: { act: "show", id: "receivePaymentNoCustomer" },
    provider: { act: "show", id: "reportHubNoProvider" },
    otherexpense: {
      act: "show",
      id: "empty",
      msg: "Please, Select an Other Expense",
    },
  };
  return map[def.autocompleteEntity] || { act: "show", id: "downloadError" };
}

function appendFilter(formData, key, value) {
  if (value === undefined || value === null || value === "") return;

  if (typeof value === "boolean") {
    formData.append(`filters[${key}]`, value ? "1" : "0");
    return;
  }

  formData.append(`filters[${key}]`, value);
}

function buildReportPdfFormData(def, filters) {
  const formData = new FormData();

  formData.append("reportName", def.reportname || def.id);
  formData.append("entity", def.entity);

  Object.keys(filters || {}).forEach((key) => {
    appendFilter(formData, key, filters[key]);
  });

  return formData;
}

function requestPdfReport(def, filters) {
  const isPdf = filters.format === "pdf";
  const getReport = isPdf ? REPORT_PDF_ENDPOINT : REPORT_SHEET_ENDPOINT;
  scrim.showLoading();

  fetch(`./${getReport}`, {
    method: "POST",
    body: buildReportPdfFormData(def, filters),
    credentials: "same-origin",
  })
    // .then(async (response) => {
    //   // 1. Leemos la respuesta como TEXTO puro para ver qué escupió PHP
    //   const textResponse = await response.text();

    //   // 2. Lo imprimimos en la consola
    //   console.log("=== RESPUESTA DE PHP ===");
    //   console.log(textResponse);

    //   // Detenemos el proceso aquí intencionalmente para que puedas leer la consola
    //   throw new Error("Detenido intencionalmente para depurar PHP");
    // })
    .then((response) => {
      if (!response.ok) throw new Error("report-pdf");
      // 1. Cambiamos .text() por .blob() para manejar el binario del PDF correctamente

      return response.blob();
    })
    .then((blob) => {
      if (isPdf) {
        // --- LÓGICA PARA PDF ---
        const pdfBlob = new Blob([blob], { type: "application/pdf" });
        const fileUrl = URL.createObjectURL(pdfBlob);
        const newTab = window.open(fileUrl, "_blank");

        if (newTab) {
          newTab.addEventListener('load', () => {
            URL.revokeObjectURL(fileUrl);
          }, { once: true });
        }
      } else {
        // --- LÓGICA PARA CSV ---
        // Se define el MIME type para CSV
        const csvBlob = new Blob([blob], { type: "text/csv;charset=utf-8;" });
        const fileUrl = URL.createObjectURL(csvBlob);

        // Creamos un enlace temporal en el DOM
        const tempLink = document.createElement("a");
        tempLink.href = fileUrl;

        // Asignamos un nombre de archivo por defecto (puedes personalizarlo)
        tempLink.setAttribute("download", `report_${new Date().getTime()}.csv`);
        tempLink.style.display = "none";

        document.body.appendChild(tempLink);
        tempLink.click(); // Disparamos la descarga

        // Limpiamos el DOM y liberamos la memoria
        document.body.removeChild(tempLink);
        URL.revokeObjectURL(fileUrl);
      }
    })
    .catch(() => {
      snack.start({ act: "show", id: "downloadError" });
    })
    .finally(() => {
      scrim.hideLoading();
    });
}


// para hacer debug
// function requestPdfReport(def, filters) {
//   scrim.showLoading();

//   const formData = buildReportPdfFormData(def, filters);
//   formData.append("debug", "1"); // para activar tu debug en PHP

//   fetch(`./${REPORT_PDF_ENDPOINT}`, {
//     method: "POST",
//     body: formData,
//     credentials: "same-origin",
//   })
//     .then((response) => response.text())
//     .then((text) => {
//       const win = window.open("", "_blank");

//       if (win) {
//         win.document.open();
//         win.document.write(`
//           <pre style="white-space:pre-wrap;font:14px monospace;padding:16px;">
// ${escapeHtml(text)}
//           </pre>
//         `);
//         win.document.close();
//       } else {
//         console.log(text);
//       }
//     })
//     .catch((error) => {
//       console.error(error);
//       snack.start({ act: "show", id: "downloadError" });
//     })
//     .finally(() => {
//       scrim.hideLoading();
//     });
// }

// function escapeHtml(value) {
//   return String(value)
//     .replace(/&/g, "&amp;")
//     .replace(/</g, "&lt;")
//     .replace(/>/g, "&gt;")
//     .replace(/"/g, "&quot;")
//     .replace(/'/g, "&#039;");
// }

// function normalizePdfPath(filePath) {
//   return String(filePath || "").trim().replace(/^["']|["']$/g, "");
// }
